export default __webpack_public_path__ + "static/5-acb44b3f2976e48288c9ec93d9c82135.jpg";